const React = require('react')
const { ConsentManager } = require('@iziwork/consent-manager');
const inEU = require('@segment/in-eu');

exports.onPreRouteUpdate = () => {
  if (analytics) {
    analytics.page();
  }
}

exports.wrapRootElement = ({ element }) => {
  let lang;
  if (typeof window !== 'undefined') {
    //Load Segment for Consent Manager
    !function () {
      const analytics = window.analytics = window.analytics || []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
        analytics.invoked = !0; analytics.methods = ["initialize", "trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];
        analytics.factory = function (t) { return function () { var e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } }; for (var t = 0; t < analytics.methods.length; t++) { var e = analytics.methods[t]; analytics[e] = analytics.factory(e) }
      }
    }();
    analytics.load = function (t, e) {
      var n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
      var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(n, a); analytics._loadOptions = e
    }; analytics.SNIPPET_VERSION = "4.1.0";

    //Detect language in url or of the navigator for Consent Manager
    if (window.location.href.indexOf('/it') > -1 || navigator.language === 'it-IT') {
      lang = 'it'
    } else if (window.location.href.indexOf('/fr') > -1 || navigator.language === 'fr-FR') {
      lang = 'fr'
    } else {
      lang = navigator.language
    }
  }

  let bannerContent;
  let bannerSubContent;
  let preferencesDialogTitle;
  let preferencesDialogContent;
  if (window.location.href.indexOf('/fr') > -1) {

    bannerContent = (
      <span>
        Notre site internet utilise des cookies <span role="img" aria-label="cookie">🍪</span>. Certains ne peuvent être
        refusés pour le bon fonctionnement du site. Pour les autres, vous pouvez
        choisir de les paramétrer {' '}. [Accepter]
      </span>
    );
    bannerSubContent = 'en cliquant ici';
    preferencesDialogTitle = 'Gérer mes préférences';
    preferencesDialogContent =
      'Nous utilisons l’information collectée par des cookies et des librairies JavaScript ' +
      'pour améliorer votre expérience de navigation, analyser le trafic sur notre site, afficher des publicités personnalisées ' +
      'et augmenter la performance de notre site.';

  } else if (window.location.href.indexOf('/it') > -1) {

    bannerContent = (
      <span>
        Questo sito utilizza i cookies <span role="img" aria-label="cookie">🍪</span>. I cookie di questo
        tipo sono necessari per il corretto funzionamento di alcune aree del sito e non possono essere
        rimossi durante la navigazione. Altri invece, possono essere impostati e gestiti secondo
        le proprie preferenze cliccando qui {' '}. [Accetta]
      </span>
    );
    bannerSubContent = 'cliccando qui';
    preferencesDialogTitle = 'Gestisci le mie preferenze';
    preferencesDialogContent =
      'Usiamo le informazioni raccolte dai cookie e dalle librerie JavaScript ' +
      'per migliorare la tua esperienza di navigazione, analizzare il traffico sul nostro sito, visualizzare pubblicità personalizzata' +
      'e aumentare le prestazioni del nostro sito.';

  }

  return (
    <div id="root">
      {element}
      <div className="consent-banner">
        <ConsentManager
          writeKey={process.env.SEGMENT_IO_KEY}
          shouldRequireConsent={inEU}
          bannerContent={bannerContent}
          bannerSubContent={bannerSubContent}
          bannerTextColor={'#031b4a'}
          bannerBackgroundColor={'white'}
          preferencesDialogTitle={preferencesDialogTitle}
          preferencesDialogContent={preferencesDialogContent}
          closeBehavior="accept"
          lang={lang}
          allowSmallBannerOnClose={true}
        />
      </div>
    </div>
  );
}